import React from 'react';

import { css } from '@flipster/styled-system/css';
import { stack } from '@flipster/styled-system/patterns';

import heroImage from '../assets/hero.webp';

const HeroSection = () => {
  return (
    <div
      className={stack({
        rounded: 8,
        h: 180,
        w: '100%',
        maxW: 400,
        mx: 'auto',
        overflow: 'hidden',
      })}
    >
      <img
        src={heroImage.src}
        alt='userpool-hero'
        className={css({
          w: '100%',
          h: '100%',
          objectFit: 'contain',
        })}
      />
    </div>
  );
};

export default HeroSection;
